import type { EnclavePower, HqUnlock } from "@zend/rules";
import { api } from "../api/http.js";

export interface HqCelebrationEvent {
  id: string; fromLevel: number; level: number; at: number;
  powerBefore: number; powerAfter: number; unlocks: HqUnlock[];
  rewards: { level: number; titleId: string; fragments: number }[];
}
export interface ProgressionState {
  power: EnclavePower;
  celebrations: HqCelebrationEvent[];
  milestones: { level: number; titleId: string; claimed: boolean }[];
  fragments: number; fragmentCost: number;
}
export interface PowerChange {
  id: string; before: number; after: number; delta: number; reason: string; at: number; power: EnclavePower;
}
export const progressionApi = {
  state: () => api<ProgressionState>("GET", "/api/base/progression"),
  seen: (id: string) => api<{ ok: boolean }>("POST", `/api/base/progression/${encodeURIComponent(id)}/seen`),
  skin: (cosmeticId: string) => api<ProgressionState>("POST", "/api/base/progression/skin", { cosmeticId }),
};
